import { mapActions, mapGetters } from 'vuex'
import { storeShopifySignupProof } from '@/utils/shopify-signup-proof'

const SHOP_PATTERN = /^[a-z0-9][a-z0-9-]*\.myshopify\.com$/i

export default {
  name: 'ShopifyInstall',
  data () {
    return {
      isLoading: true,
      error: null,
      shop: null
    }
  },
  computed: {
    ...mapGetters([
      'apiUrl'
    ])
  },
  methods: {
    ...mapActions([
      'authShopifyInstall'
    ]),
    collectInstallQuery () {
      return Object.fromEntries(new URLSearchParams(window.location.search).entries())
    },
    async processInstall () {
      try {
        const query = this.collectInstallQuery()
        this.shop = query.shop

        if (!this.shop) throw new Error('Missing shop parameter.')
        if (!SHOP_PATTERN.test(this.shop)) throw new Error('Invalid shop domain format.')

        const shop = this.shop.toLowerCase()
        console.log('Shopify app install - storing shop:', shop)
        storeShopifySignupProof({ shop })

        const hasToken = Boolean(window.localStorage.getItem('jwt'))
        if (hasToken) {
          window.location.href = '/workspace'
          return
        }

        const result = await this.authShopifyInstall(query)
        if (!result?.proof) throw new Error('Shopify install could not be verified.')
        storeShopifySignupProof({ proof: result.proof, shop: result.shop || shop })
        const params = new URLSearchParams({
          shopifyProof: result.proof,
          shop: result.shop || shop
        })
        window.location.href = `/mini?${params.toString()}`
      } catch (error) {
        console.error('Error processing Shopify install:', error)
        this.error = error.response?.data?.message || error.message
        this.isLoading = false
      }
    }
  },
  mounted () {
    this.processInstall()
  }
}
